export default "__VITE_ASSET__Bl5a8zYL__"